/* istanbul ignore file */
import React from 'react';
import { EnumDropdown, DefaultInputPropTypes } from 'framework/form';
import { EXPENSE_STATUSES_OPTIONS } from 'domain/shared/expense';

const ExpenseStatusDropdown = (props: DefaultInputPropTypes<string>) => {
  return <EnumDropdown options={EXPENSE_STATUSES_OPTIONS} label="Status" {...props} />;
};

export default ExpenseStatusDropdown;
